// extracted by mini-css-extract-plugin
export default {"words":"login_words__uaa2u","move":"login_move__CG9ds"};